import instance from './instance';

// Utils
import { convertObjectKeysToSnakeCase } from 'Shared/utils/convertObjectKeysToSnakeCase.utils';

// Types
import { ReviewTemplateTypeType, ReviewTemplateVersion } from 'Shared/types/ReviewTemplates.type';

export const fetchReviewTemplate = (reviewTemplateSlug: string, params?) =>
  instance.get(`/review_templates/${reviewTemplateSlug}`, { params });

export const fetchReviewTemplates = ({ templateType }: { templateType: ReviewTemplateTypeType }) =>
  instance.get(`/review_templates?template_type=${templateType}`);

export type createReviewTempateDataType = {
  name: string;
  description: string;
  templateType: ReviewTemplateTypeType;
  version: ReviewTemplateVersion;
  duplicateFromSlug?: string;
};
export const createReviewTemplate = ({
  name,
  description,
  templateType,
  duplicateFromSlug,
  version,
}: createReviewTempateDataType) =>
  instance.post(`/review_templates`, {
    name,
    description,
    template_type: templateType,
    duplicate_from_slug: duplicateFromSlug,
    version,
  });

export type duplicateReviewTempateDataType = {
  name: string;
  duplicateFromSlug: string;
};
export const duplicateReviewTemplate = ({ name, duplicateFromSlug }: duplicateReviewTempateDataType) =>
  instance.post(`/review_templates`, {
    name,
    duplicate_from_slug: duplicateFromSlug,
  });

export type updateReviewTemplateDataType = {
  slug: string;
  reviewTemplate;
};
export const updateReviewTemplate = ({ slug, reviewTemplate }: updateReviewTemplateDataType) =>
  instance.put(`/review_templates/${slug}`, convertObjectKeysToSnakeCase(reviewTemplate));

export type deleteReviewTemplateDataType = {
  slug: string;
};
export const deleteReviewTemplate = ({ slug }: deleteReviewTemplateDataType) =>
  instance.delete(`/review_templates/${slug}`);
